import { OnboardingResponse, RequiredPageProps } from 'types';

export type FileProps = {
  name?: string;
  size?: number;
  displayPreview?: boolean;
  url?: string;
  error?: unknown;
};

export const MAX_FILE_SIZE = 2000000;

export enum DocumentType {
  ID_CARD = "Carta d'identita",
  PASSPORT = 'Passaporto',
  FOREIGN_PASSPORT = 'PASES',
  DRIVING_LICENSE = 'Patente di guida'
}

export type DocumentUploadPayload = {
  documentTypeCodes: DocumentType[];
  status: DocumentUploadStatus;
  identificationType: string;
  legalRepresentativeData: {
    name: string;
    surname: string;
    fiscalCode: string;
    birthDate: string;
  };
  selectedDocumentData: {
    documentCode: DocumentType | '';
    issuerPlace: string;
    issueDate: string;
    expiryDate: string;
    documentNumber: string;
    issuerNation?: string;
    provinceIssuer: string;
  };
  documents: UploadedDocument[];
};

export enum UploadedDocumentNames {
  FRONT = 'FRONT_IDENTIFICATION_DOCUMENT',
  BACK = 'BACK_IDENTIFICATION_DOCUMENT'
}

export type UploadedDocument = {
  bytes?: number;
  fileType: UploadedDocumentNames;
  error?: string;
};

export enum DocumentUploadStatus {
  TO_BE_STARTED = 'TO_BE_STARTED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  MISSING_INFO = 'MISSING_INFO'
}
export type UploadedDocuments = { [K in UploadedDocumentNames]?: UploadedDocument } | undefined;

export type DocumentUploadInfo = {};

export type PageProps = RequiredPageProps & Partial<DocumentUploadProps>;

export type DocumentUploadProps = {
  pageLabels: any;
  documentUpload: OnboardingResponse<DocumentUploadPayload>;
};
